import React from "react";
import { useTranslation } from "react-i18next";
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';

interface DeclineCIReferralProps {
    reason: string;
    onReasonChange: (reason: string) => void;
}

export const DeclineCIReferral: React.FC<DeclineCIReferralProps> = ({ reason, onReasonChange }) => {
    const { t } = useTranslation('criticalIncident', { useSuspense: false });

    const reasons = [
        t('decline_reason1'),
        t('decline_reason2'),
        t('decline_reason3'),
        t('decline_reason4'),
    ];

    return (
        <div className="decline-ci-referral-root">
            <div className="illustration">
                <picture>
                    <source srcSet="/images/Cherry_Blossom_Individual_Surface_BH_HR_RGB-1.png" media="(max-width: 768px) and (prefers-color-scheme: dark)" />
                    <source srcSet="/images/Cherry_Blossom_Individual_Surface_BH_HR_RGB.png" media="(min-width: 769px) and (prefers-color-scheme: dark)" />
                    <source srcSet="/images/white_purple_flower_mobile.jpg" media="(max-width: 768px) and (prefers-color-scheme: light)" />
                    <source srcSet="/images/white_purple_flower.jpg" media="(min-width: 769px) and (prefers-color-scheme: light)" />
                    <img src="/images/Cherry_Blossom_Individual_Surface_BH_HR_RGB.png" alt="Flower illustration" width="344" height="218" />
                </picture>
            </div>

            <div className="bottom-half">
                <h1>{t('referral_declined')}</h1>
                <p>{t('referral_declined_instruction')}</p>
                <FormControl fullWidth>
                    <RadioGroup
                        aria-labelledby="demo-controlled-radio-buttons-group"
                        name="controlled-radio-buttons-group"
                        value={reason}
                        onChange={(e) => onReasonChange(e.target.value)}
                    >
                        {reasons.map((rsn) => <FormControlLabel value={rsn} control={<Radio />} label={rsn} key={rsn} />)}
                    </RadioGroup>
                </FormControl>
            </div>
        </div>
    );
};
